export const UserInfo = ({ userDetails }) => {
  return (
    <div className="flex align-items-center text-color">
      <div className="flex flex-column align">
        <span className="font-bold text-primary">{userDetails?.username}</span>
        <span className="text-sm">
          {userDetails?.accessName?.toUpperCase()}
        </span>
      </div>
    </div>
  );
};
